import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useRatioCache } from './cache'
import { type RatioRemoveInput, type RatioRemoveSuccess, toResponseError } from '@terros/common'

export const useRemoveRatio = (): RemoveHookResponse<RatioRemoveInput> => {
  const cache = useRatioCache()
  const mutation = useTantalimMutation<RatioRemoveInput, RatioRemoveSuccess>({
    url: '/ratio/remove',
  })

  const remove = async (input: RatioRemoveInput) => {
    try {
      await mutation.mutateAsync(input)
      cache.clearItem(input.ratioId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
